<div class="px-5 pb-5">
  <div class="flex flex-col lg:flex-row lg:items-center justify-between my-5 gap-6">
    <div class="flex flex-wrap items-center gap-3 flex-1 min-w-0">
      <!-- Filter Bar -->
      <cdw-ae-filter-bar-core
        class="flex-1 min-w-0"
        [filterBarField]="filterBarSettings"
        [fieldMask$]="fieldMask$"
        [initialSelectedFilterFields$]="selectedFilters$"
        [dialogComponent]="filterBarDialogComponent"
        (filtersChange)="filtersChange.emit($event)"
      ></cdw-ae-filter-bar-core>
    </div>

    <div class="flex flex-row items-center gap-1">
      <mat-icon class="!text-[20px] !w-[20px] !h-[20px] align-middle material-icons-outlined"> info </mat-icon>
      <span class="text-gray-300">Data is filtered for active devices by default</span>
    </div>

    <div class="flex items-center gap-3">
      <!-- <div class="px-3 py-2 bg-blue-100 rounded text-[16px] font-bold text-tertiary-blue-cta">Org Unit Picker</div> -->
    </div>
  </div>

  <div class="dashboard-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
    <!-- Top Row -->
    <!-- Device Status Card (Large) -->
    <div
      class="large-card col-span-1 md:col-span-2 lg:col-span-2 dashboard-card border border-gray-300 rounded-lg p-4 bg-white overflow-hidden flex flex-col hover:shadow-lg transition-shadow duration-200"
      data-test="dashboard-card-device-status"
    >
      <!-- Header -->
      <div class="chart-header flex flex-row justify-between items-start mb-4 flex-shrink-0">
        <div class="flex-1 min-w-0">
          <h3 class="text-[16px] text-gray-400 mb-1 leading-tight">Devices last active</h3>
        </div>
        <button
          (click)="cardAction.emit({ cardId: CardType.DEVICE_LAST_ACTIVE_CARD, clickedValue: 'devices', targetFilterBar: deviceSearchFilterBarId })"
          class="flex items-center justify-center gap-1 text-sm text-[16px] text-tertiary-blue-cta whitespace-nowrap"
          type="button"
        >
          See Devices
          <mat-icon class="!text-[14px] !w-[14px] !h-[14px] align-middle">open_in_new</mat-icon>
        </button>
      </div>

      <!-- Chart Content -->
      <div class="flex-1 flex flex-col">
        <div *ngIf="isDevicesLastActiveSummaryDataLoading" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesLastActiveSummaryDataLoading && !hasBarData()" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesLastActiveSummaryDataLoading && hasBarData()" class="flex-1">
          <spog-bar-chart
            [chartType]="ChartType.DEVICE_INACTIVITY"
            [dataSource]="dashboardData.deviceLastActiveSummary"
            [currentFilters]="currentFilters"
            [gradient]="false"
            [showXAxis]="true"
            [showYAxis]="true"
            [showLegend]="false"
            [showYAxisLabel]="false"
            [showXAxisLabel]="false"
            [showGridLines]="true"
            [animations]="true"
            [tooltipDisabled]="false"
            class="w-full h-full"
          ></spog-bar-chart>
        </div>
      </div>
    </div>

    <!-- Auto Update Expiry Card (Large) -->
    <div
      class="large-card col-span-1 md:col-span-2 lg:col-span-2 dashboard-card border border-gray-300 rounded-lg p-4 bg-white shadow-md overflow-hidden flex flex-col hover:shadow-lg transition-shadow duration-200"
      data-test="dashboard-card-auto-update-expiry"
    >
      <!-- Header -->
      <div class="chart-header flex flex-row justify-between items-start mb-4 flex-shrink-0">
        <div class="flex-1 min-w-0">
          <h3 class="text-[16px] text-gray-400 mb-1 leading-tight">Devices by AUE dates</h3>
        </div>
        <button
          (click)="cardAction.emit({ cardId: CardType.AUTO_UPDATE_EXPIRY_CARD, clickedValue: 'devices', targetFilterBar: deviceSearchFilterBarId })"
          class="flex items-center justify-center gap-1 text-sm text-[16px] text-tertiary-blue-cta text-tertiary-blue-cta whitespace-nowrap"
          type="button"
        >
          See Devices
          <mat-icon class="!text-[14px] !w-[14px] !h-[14px] align-middle">open_in_new</mat-icon>
        </button>
      </div>

      <!-- Chart Content -->
      <div class="flex-1 flex flex-col">
        <div *ngIf="isDevicesAueSummaryDataLoading" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesAueSummaryDataLoading && !hasPieData()" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesAueSummaryDataLoading && hasPieData()" class="flex-1">
          <spog-pie-chart
            [chartType]="ChartType.AUTO_UPDATE_EXPIRY"
            [actionTrigger]="actionTrigger"
            [dataSource]="dashboardData.deviceAueSummary"
            [currentFilters]="currentFilters"
            [gradient]="false"
            [showLegend]="true"
            [labels]="false"
            [leftAlign]="true"
            [doughnut]="true"
            [showCenterLabel]="true"
            class="w-full h-full"
          ></spog-pie-chart>
        </div>
      </div>
    </div>

    <!-- Middle Row -->
    <!-- Battery Health Card (Small) -->
    <div
      class="standard-card items-center gauge-card col-span-1 dashboard-card border border-gray-300 rounded-lg p-4 bg-white shadow-md overflow-hidden flex flex-col hover:shadow-lg transition-shadow duration-200"
      data-test="dashboard-card-battery-health"
    >
      <!-- Header -->
      <div class="chart-header flex flex-row justify-between items-start flex-shrink-0">
        <div class="flex-1 min-w-0">
          <h3 class="text-[16px] text-gray-400 leading-tight text-center">Poor Battery Health</h3>
        </div>
      </div>

      <!-- Chart Content -->
      <div class="flex-1 flex flex-col">
        <div *ngIf="isDevicesBatteryHealthSummaryDataLoading" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </div>

        <div
          *ngIf="!isDevicesBatteryHealthSummaryDataLoading && !hasGaugeData()"
          class="flex-1 flex items-center justify-center"
        >
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesBatteryHealthSummaryDataLoading && hasGaugeData()" class="flex-1 flex flex-col">
          <div class="flex-1">
            <spog-gauge-chart
              [chartType]="ChartType.BATTERY_HEALTH"
              [gaugeLabel]="'Poor Battery Health'"
              [actionTrigger]="actionTrigger"
              [dataSource]="dashboardData.batteryHealthSummary?.poorBatteryHealth || 0"
              [currentFilters]="currentFilters"
              [showXAxis]="false"
              [showYAxis]="true"
              [showLegend]="false"
              [animations]="true"
              [tooltipDisabled]="false"
              class="w-full h-full"
            ></spog-gauge-chart>
          </div>

          <div class="self-center mt-2">
            <button
              (click)="cardAction.emit({ cardId: CardType.POOR_BATTERY_HEALTH_CARD, clickedValue: 'default' })"
              class="flex items-center justify-center gap-1 text-sm text-[16px] text-tertiary-blue-cta font-bold text-tertiary-blue-cta whitespace-nowrap"
              type="button"
            >
              Generate Report
              <mat-icon class="!text-[14px] !w-[14px] !h-[14px] align-middle">open_in_new</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Storage Usage Card (Small) -->
    <div
      class="standard-card items-center gauge-card col-span-1 dashboard-card border border-gray-300 rounded-lg p-4 bg-white shadow-md overflow-hidden flex flex-col hover:shadow-lg transition-shadow duration-200"
      data-test="dashboard-card-storage-usage"
    >
      <!-- Header -->
      <div class="chart-header flex flex-row justify-between items-start flex-shrink-0">
        <div class="flex-1 min-w-0">
          <h3 class="text-[16px] text-gray-400 leading-tight text-center">Storage More Than 80% Full</h3>
        </div>
      </div>

      <!-- Chart Content -->
      <div class="flex-1 flex flex-col">
        <div *ngIf="isDevicesBatteryHealthSummaryDataLoading" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </div>

        <div
          *ngIf="!isDevicesBatteryHealthSummaryDataLoading && !hasGaugeData()"
          class="flex-1 flex items-center justify-center"
        >
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesBatteryHealthSummaryDataLoading && hasGaugeData()" class="flex-1 flex flex-col">
          <div class="flex-1">
            <spog-gauge-chart
              [chartType]="ChartType.STORAGE_USAGE"
              [gaugeLabel]="'Storage > 80% Full'"
              [actionTrigger]="actionTrigger"
              [dataSource]="dashboardData.batteryHealthSummary?.storageMoreThan80Full || 0"
              [currentFilters]="currentFilters"
              [showXAxis]="false"
              [showYAxis]="true"
              [showLegend]="false"
              [animations]="true"
              [tooltipDisabled]="false"
              class="w-full h-full"
            ></spog-gauge-chart>
          </div>

          <div class="self-center mt-2">
            <button
              (click)="cardAction.emit({ cardId: CardType.STORAGE_USAGE_OVER_80_CARD, clickedValue: 'devices', targetFilterBar: deviceSearchFilterBarId })"
              [disabled]="!dashboardData.batteryHealthSummary?.storageMoreThan80Full || dashboardData.batteryHealthSummary?.storageMoreThan80Full === 0"
              [class.text-gray-400]="!dashboardData.batteryHealthSummary?.storageMoreThan80Full || dashboardData.batteryHealthSummary?.storageMoreThan80Full === 0"
              [class.opacity-70]="!dashboardData.batteryHealthSummary?.storageMoreThan80Full || dashboardData.batteryHealthSummary?.storageMoreThan80Full === 0"
              [class.text-tertiary-blue-cta]="(dashboardData.batteryHealthSummary?.storageMoreThan80Full ?? 0) > 0"
              class="flex items-center justify-center gap-1 text-sm text-[16px] font-bold whitespace-nowrap"
              type="button"
            >
              Wipe Profiles
              <mat-icon class="!text-[14px] !w-[14px] !h-[14px] align-middle">open_in_new</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- OS Versions Behind Card (Small) -->
    <div
      class="standard-card items-center gauge-card col-span-1 dashboard-card border border-gray-300 rounded-lg p-4 bg-white shadow-md overflow-hidden flex flex-col hover:shadow-lg transition-shadow duration-200"
      data-test="dashboard-card-os-versions-behind"
    >
      <!-- Header -->
      <div class="chart-header flex flex-row justify-between items-start flex-shrink-0">
        <div class="flex-1 min-w-0">
          <h3 class="text-[16px] text-gray-400 leading-tight text-center">More Than 3 OS Versions Behind</h3>
        </div>
      </div>

      <!-- Chart Content -->
      <div class="flex-1 flex flex-col">
        <div *ngIf="isDevicesBatteryHealthSummaryDataLoading" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </div>

        <div
          *ngIf="!isDevicesBatteryHealthSummaryDataLoading && !hasGaugeData()"
          class="flex-1 flex items-center justify-center"
        >
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesBatteryHealthSummaryDataLoading && hasGaugeData()" class="flex-1 flex flex-col">
          <div class="flex-1">
            <spog-gauge-chart
              [chartType]="CardType.OS_VERSION_OVER_3_BEHIND_CARD"
              [gaugeLabel]="'3+ OS Versions Behind'"
              [actionTrigger]="actionTrigger"
              [dataSource]="dashboardData.batteryHealthSummary?.moreThan3OsVersionsBehind || 0"
              [currentFilters]="currentFilters"
              [showXAxis]="false"
              [showYAxis]="true"
              [showLegend]="false"
              [animations]="true"
              [tooltipDisabled]="false"
              class="w-full h-full"
            ></spog-gauge-chart>
          </div>

          <div class="self-center mt-2">
            <button
              (click)="
                cardAction.emit({
                  cardId: CardType.OS_VERSION_OVER_3_BEHIND_CARD,
                  clickedValue: 'os-version-over-3-behind',
                  targetFilterBar: deviceSearchFilterBarId
                })
              "
              class="flex items-center justify-center gap-1 text-sm text-[16px] font-bold text-tertiary-blue-cta font-bold text-tertiary-blue-cta whitespace-nowrap"
              type="button"
            >
              See Devices
              <mat-icon class="!text-[14px] !w-[14px] !h-[14px] align-middle">open_in_new</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- AUE in next 90 days Card (Small) -->
    <div
      class="standard-card items-center gauge-card col-span-1 dashboard-card border border-gray-300 rounded-lg p-4 bg-white shadow-md overflow-hidden flex flex-col hover:shadow-lg transition-shadow duration-200"
      data-test="dashboard-card-auto-update-expiry-90-days"
    >
      <!-- Header -->
      <div class="chart-header flex flex-row justify-between items-start flex-shrink-0">
        <div class="flex-1 min-w-0">
          <h3 class="text-[16px] text-gray-400 leading-tight text-center">AUE in next 90 days</h3>
        </div>
      </div>

      <!-- Chart Content -->
      <div class="flex-1 flex flex-col">
        <div *ngIf="isDevicesBatteryHealthSummaryDataLoading" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </div>

        <div
          *ngIf="!isDevicesBatteryHealthSummaryDataLoading && !hasGaugeData()"
          class="flex-1 flex items-center justify-center"
        >
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesBatteryHealthSummaryDataLoading && hasGaugeData()" class="flex-1 flex flex-col">
          <div class="flex-1">
            <spog-gauge-chart
              [chartType]="CardType.AUE_IN_90_DAYS_CARD"
              [gaugeLabel]="'AUE in Next 90 Days'"
              [actionTrigger]="actionTrigger"
              [dataSource]="dashboardData.batteryHealthSummary?.autInNext90Days || 0"
              [currentFilters]="currentFilters"
              [showXAxis]="false"
              [showYAxis]="true"
              [showLegend]="true"
              [animations]="true"
              [tooltipDisabled]="false"
              class="w-full h-full"
            ></spog-gauge-chart>
          </div>

          <div class="self-center mt-2">
            <button
              (click)="cardAction.emit({ cardId: CardType.AUE_IN_90_DAYS_CARD, clickedValue: 'devices' })"
              class="flex items-center justify-center gap-1 text-sm text-[16px] font-bold text-tertiary-blue-cta font-bold text-tertiary-blue-cta whitespace-nowrap"
              type="button"
            >
              See Devices
              <mat-icon class="!text-[14px] !w-[14px] !h-[14px] align-middle">open_in_new</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Row -->
    <!-- OS Version Status Card (Large) -->
    <div
      class="large-card col-span-1 md:col-span-2 lg:col-span-2 dashboard-card border border-gray-300 rounded-lg p-4 bg-white shadow-md overflow-hidden flex flex-col hover:shadow-lg transition-shadow duration-200"
      data-test="dashboard-card-os-version-status"
    >
      <!-- Header -->
      <div class="chart-header flex flex-row justify-between items-start mb-4 flex-shrink-0">
        <div class="flex-1 min-w-0">
          <h3 class="text-[16px] text-gray-400 mb-1 leading-tight">Device OS Version Status (Last 6 Months)</h3>
        </div>
        <button
          (click)="
            cardAction.emit({
              cardId: CardType.DEVICE_OS_VERSION_STATUS_CARD,
              clickedValue: 'os-version-over-3-behind',
              targetFilterBar: deviceSearchFilterBarId
            })
          "
          class="flex items-center justify-center gap-1 text-sm text-[16px] text-tertiary-blue-cta text-tertiary-blue-cta whitespace-nowrap"
          type="button"
        >
          See Devices 3+ OS Behind
          <mat-icon class="!text-[14px] !w-[14px] !h-[14px] align-middle font-bold">open_in_new</mat-icon>
        </button>
      </div>

      <!-- Chart Content -->
      <div class="flex-1 flex flex-col">
        <div *ngIf="isDevicesVersionSummaryDataLoading" class="flex-1 flex items-center justify-center">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </div>

        <div
          *ngIf="!isDevicesVersionSummaryDataLoading && !hasBarData()"
          class="flex-1 flex items-center justify-center"
        >
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </div>

        <div *ngIf="!isDevicesVersionSummaryDataLoading && hasBarData()" class="flex-1">
          <spog-bar-chart
            [chartType]="ChartType.OS_VERSION_STATE"
            [actionTrigger]="actionTrigger"
            [dataSource]="dashboardData.deviceVersionSummary"
            [currentFilters]="currentFilters"
            [gradient]="false"
            [showXAxis]="true"
            [showYAxis]="true"
            [showLegend]="false"
            [showYAxisLabel]="false"
            [showXAxisLabel]="false"
            [showGridLines]="true"
            [animations]="true"
            [tooltipDisabled]="false"
            class="w-full h-full"
          ></spog-bar-chart>
        </div>
      </div>
    </div>

    <!-- Generate Report Grid with smaller generate cards within -->
    <div
      class="large-card col-span-1 md:col-span-2 lg:col-span-2 overflow-hidden flex flex-col gap-6 overflow-hidden flex flex-col hover:shadow-lg transition-shadow duration-200"
      data-test="dashboard-card-generic-reports"
    >
      <!-- Top Row: Single User and Single Device Reports -->
      <div class="flex flex-col sm:flex-row gap-6 flex-[1]">
        <!-- Single User Report -->
        <div
          class="flex-1 border border-gray-300 rounded-lg bg-white flex flex-col dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 px-3"
        >
          <div class="flex flex-row items-center gap-3 py-2 h-full">
            <img src="images/reports/student_icon.svg" alt="User Report" class="h-full w-auto max-h-12" />
            <div class="flex-1 flex-start h-full">
              <h4 class="text-sm text-[16px] text-gray-400">Single user report</h4>
            </div>
          </div>
          <div class="border-t border-gray-200 py-1.5">
            <button
              class="text-[16px] text-tertiary-blue-cta text-tertiary-blue-cta text-sm text-[16px] text-gray-400"
              type="button"
              (click)="cardAction.emit({ cardId: CardType.SINGLE_USER_REPORT_CARD, clickedValue: 'reports' })"
            >
              Generate report
            </button>
          </div>
        </div>

        <!-- Single Device Report -->
        <div
          class="flex-1 border border-gray-300 rounded-lg bg-white flex flex-col dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 px-3"
        >
          <div class="flex flex-row items-center gap-3 py-2 h-full">
            <img src="images/reports/laptop_icon.svg" alt="Device Report" class="h-full w-auto max-h-12" />
            <div class="flex-1 flex-start h-full">
              <h4 class="text-sm text-[16px] text-gray-400">Single device report</h4>
            </div>
          </div>
          <div class="border-t border-gray-200 py-1.5">
            <button
              class="text-[16px] text-tertiary-blue-cta text-tertiary-blue-cta text-sm text-[16px] text-gray-400"
              type="button"
              (click)="cardAction.emit({ cardId: CardType.SINGLE_DEVICE_REPORT_CARD, clickedValue: 'reports' })"
            >
              Generate report
            </button>
          </div>
        </div>
      </div>

      <!-- Bottom Row: Aggregate Report - ENABLED -->
      <div
        class="flex flex-row items-center border border-gray-300 rounded-lg bg-white p-4 gap-6 flex-[2] pl-0 dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200"
      >
        <img src="images/reports/agrr_reports_icon.svg" alt="Aggregate Report" class="h-28" />
        <div class="flex flex-col h-full w-full justify-between border-l border-gray-300 pl-4">
          <div>
            <h4 class="!text-[18px] text-[16px] text-gray-400 mb-1">Aggregate reports</h4>
            <p class="text-sm text-gray-600">
              Generate reports such as 15-day OU activity, overall Chrome versions and by OU, Model/AUE, Model/AUE by
              OU, and daily activity by OU.
            </p>
          </div>
          <div class="flex justify-end">
            <lib-cdw-dropdown-menu
              [buttonLabel]="'Select report'"
              [fontFamily]="'Roboto'"
              [fontSize]="'14px'"
              [paddingLeft]="'1rem'"
              [borderColor]="tertiaryBlueCta"
              [options]="aggregateReportMenuOptions"
              [level]="'primary'"
              [dropdownArrowPosition]="'right'"
              [panelPosition]="'after'"
              [panelWidth]="'350px'"
              (optionSelected)="aggregateReportSelect.emit($event)">
            </lib-cdw-dropdown-menu>
          </div>
        </div>
      </div>
    </div>

    <!-- Reusable Loading Template -->
    <ng-template #loadingTemplate>
      <div class="flex flex-col items-center justify-center text-gray-500">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-3"></div>
        <p class="text-sm">Loading chart data...</p>
      </div>
    </ng-template>

    <!-- Reuseable no data available template-->
    <ng-template #noDataTemplate>
      <div class="text-center">
        <div class="text-gray-400 mb-2">
          <mat-icon class="text-4xl">pie_chart</mat-icon>
        </div>
        <p class="text-gray-500 text-sm">No data available</p>
      </div>
    </ng-template>
  </div>
</div>
